import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined"
import CommentOutlinedIcon from "@mui/icons-material/CommentOutlined"
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined"
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined"
import * as React from "react"
import {UserSubscription} from "../../../../models"


export default function NotificationIcons({subscription}: {
    subscription?: UserSubscription
}) {
    switch (true) {
        case !!subscription?.articleId:
            return <ArticleOutlinedIcon titleAccess="article" />
        case !!subscription?.discussionId:
            return <GroupsOutlinedIcon titleAccess="discussion" />
        case !!subscription?.productId:
            return <Inventory2OutlinedIcon titleAccess="product" />
        default:
            return <CommentOutlinedIcon titleAccess="comment" />
    }
}
